import { CmsPageContent } from "@shared/graphql";
import { Wrapper } from ".";
import Skeleton from "react-loading-skeleton";

import "./banner.scss";

type Props = {
  loading:boolean,
  data:CmsPageContent | undefined,
};

const Banner = ({ loading, data }: Props) => {
  if (!loading && !data) return null;

  if(loading){
    return(
      <Wrapper.Centered className="banner">
        <h1><Skeleton width="65%" /></h1>
        <hr></hr>
        <p>
          <Skeleton height={20} width="100%" />
          <Skeleton height={20} width="85%" />
          <Skeleton height={20} width="70%" />
        </p>
      </Wrapper.Centered>
    );
  }


  const header = data!["header"];

  return(
      <Wrapper.Centered className="banner">
        <h1>{header["header-title"]}</h1>
        <hr></hr>
        <div  className="desc"
              dangerouslySetInnerHTML={{ __html: header["header-lead"] }} />
      </Wrapper.Centered>
  );
}

export default Banner;
